import { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import './Contact.css';
import { FaWhatsapp, FaInstagram, FaYoutube, FaEnvelope } from 'react-icons/fa';

function validateContact(form) {
  const errors = {};
  if (!form.name.trim())
    errors.name = 'Full name is required';
  else if (form.name.trim().length < 3)
    errors.name = 'Name must be at least 3 characters';

  if (!form.mobile.trim())
    errors.mobile = 'Mobile number is required';
  else if (!/^[6-9]\d{9}$/.test(form.mobile.trim()))
    errors.mobile = 'Enter a valid 10-digit Indian mobile number';

  if (!form.email.trim())
    errors.email = 'Email address is required';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()))
    errors.email = 'Enter a valid email address';

  return errors;
}

function Contact() {
  const [activePill, setActivePill] = useState('Course Enquiry');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({ name: '', mobile: '', email: '', message: '' });

  const pills = [
    'Course Enquiry', 'NISM / NCFM Certification',
    'Weekend Course', 'Advanced Diploma',
    'Pricing & Payment', 'Free Demo Class', 'Other',
  ];

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors(prev => ({ ...prev, [e.target.name]: '' }));
  };

  const handleSubmit = async () => {
    const validationErrors = validateContact(form);
    if (Object.keys(validationErrors).length > 0) { setErrors(validationErrors); return; }

    setLoading(true);
    try {
      await emailjs.send('service_w124raa', 'template_uj1aj2t', {
        from_name: form.name, mobile: form.mobile,
        from_email: form.email, subject: activePill,
        message: form.message || 'No message provided',
      }, '0jEeQ08-qjREnTQkq');
      setSubmitted(true);
    } catch (error) {
      console.error('EMAIL ERROR:', error);
      alert('Failed to send message. Please WhatsApp us directly at +91 94302 93305');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact">

      {/* HERO */}
      <section className="ct-hero">
        <div className="ct-hero-inner">
          <div className="ct-tag">Get In Touch</div>
          <h1>We're Here to <span>Help You</span></h1>
          <div className="ct-gold-line"></div>
          <p>Have a question about courses, certifications or enrolment? Reach out — we respond within 24 hours.</p>
        </div>
      </section>

      {/* MAIN */}
      <div className="ct-main">

        {/* LEFT */}
        <div className="ct-left">
          <div className="ct-sec-label">Reach us directly</div>
          <h2 className="ct-sec-title">Contact Details</h2>

          <a href="https://wa.me/919430293305" className="ct-card" target="_blank" rel="noreferrer">
            <div className="ct-icon ct-wa"><FaWhatsapp /></div>
            <div className="ct-info">
              <div className="ct-label">WhatsApp</div>
              <div className="ct-val">+91 94302 93305</div>
              <div className="ct-hint">Fastest response — chat directly</div>
            </div>
            <div className="ct-arrow">→</div>
          </a>

          <a href="mailto:theatharvavedaequity@gmail.com" className="ct-card">
            <div className="ct-icon ct-email"><FaEnvelope /></div>
            <div className="ct-info">
              <div className="ct-label">Email</div>
              <div className="ct-val">theatharvavedaequity@gmail.com</div>
              <div className="ct-hint">Reply within 24 hours</div>
            </div>
            <div className="ct-arrow">→</div>
          </a>

          <a href="https://instagram.com/atharvavedaequity" className="ct-card" target="_blank" rel="noreferrer">
            <div className="ct-icon ct-ig"><FaInstagram /></div>
            <div className="ct-info">
              <div className="ct-label">Instagram</div>
              <div className="ct-val">@atharvavedaequity</div>
              <div className="ct-hint">Daily market insights & updates</div>
            </div>
            <div className="ct-arrow">→</div>
          </a>

          <a href="https://youtube.com/@atharvavedaequity" className="ct-card" target="_blank" rel="noreferrer">
            <div className="ct-icon ct-yt"><FaYoutube /></div>
            <div className="ct-info">
              <div className="ct-label">YouTube</div>
              <div className="ct-val">The Atharva Veda Equity</div>
              <div className="ct-hint">Free lessons & market analysis</div>
            </div>
            <div className="ct-arrow">→</div>
          </a>

          <div className="ct-hours">
            <div className="ct-hours-title">🕐 Support Hours</div>
            <div className="ct-hours-row"><span>Monday — Friday</span><span>9:00 AM — 7:00 PM</span></div>
            <div className="ct-hours-row"><span>Saturday</span><span>10:00 AM — 5:00 PM</span></div>
            <div className="ct-hours-row"><span>Sunday</span><span>Closed</span></div>
            <div className="ct-hours-live">
              <span className="ct-live-dot"></span>
              WhatsApp available during market hours
            </div>
          </div>
        </div>

        {/* RIGHT FORM */}
        <div className="ct-right">
          {!submitted ? (
            <>
              <h2 className="ct-form-title">Send us a Message</h2>
              <p className="ct-form-sub">Fill in the form and we'll get back to you shortly.</p>

              <div className="ct-form">
                <div className="ct-row">
                  <div className="ct-field">
                    <label>Full Name *</label>
                    <input type="text" name="name" placeholder="Your full name"
                      value={form.name} onChange={handleChange}
                      className={errors.name ? 'ct-input-error' : ''}/>
                    {errors.name && <span className="ct-error">{errors.name}</span>}
                  </div>
                  <div className="ct-field">
                    <label>Mobile Number *</label>
                    <input type="tel" name="mobile" placeholder="10-digit mobile number"
                      value={form.mobile} onChange={handleChange} maxLength={10}
                      className={errors.mobile ? 'ct-input-error' : ''}/>
                    {errors.mobile && <span className="ct-error">{errors.mobile}</span>}
                  </div>
                </div>

                <div className="ct-field">
                  <label>Email Address *</label>
                  <input type="email" name="email" placeholder="your@email.com"
                    value={form.email} onChange={handleChange}
                    className={errors.email ? 'ct-input-error' : ''}/>
                  {errors.email && <span className="ct-error">{errors.email}</span>}
                </div>

                <div className="ct-field">
                  <label>Subject</label>
                  <div className="ct-pills">
                    {pills.map(p => (
                      <button key={p}
                        className={`ct-pill ${activePill === p ? 'active' : ''}`}
                        onClick={() => setActivePill(p)}>{p}</button>
                    ))}
                  </div>
                </div>

                <div className="ct-field">
                  <label>Message</label>
                  <textarea name="message" rows="4" placeholder="Tell us how we can help..."
                    value={form.message} onChange={handleChange}/>
                </div>

                <div className="ct-submit-row">
                  <button type="button" className="ct-submit"
                    onClick={handleSubmit} disabled={loading}>
                    {loading ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="ct-success">
              <div className="ct-success-icon">✓</div>
              <h2 className="ct-success-title">Message Sent!</h2>
              <p className="ct-success-sub">Thank you! We'll get back to you within 24 hours. For faster response, WhatsApp us directly.</p>
              <a href="https://wa.me/919430293305" className="ct-wa-btn" target="_blank" rel="noreferrer">
                💬 Chat on WhatsApp
              </a>
            </div>
          )}
        </div>
      </div>

      {/* SOCIAL STRIP */}
      <div className="ct-social">
        <div className="ct-social-label">Connect With The Atharva Veda Equity</div>
        <div className="ct-social-icons">
          <a href="https://wa.me/919430293305" target="_blank" rel="noreferrer" className="ct-si ct-si-wa">
            <FaWhatsapp /><span>WhatsApp</span>
          </a>
          <a href="https://instagram.com/atharvavedaequity" target="_blank" rel="noreferrer" className="ct-si ct-si-ig">
            <FaInstagram /><span>Instagram</span>
          </a>
          <a href="https://youtube.com/@atharvavedaequity" target="_blank" rel="noreferrer" className="ct-si ct-si-yt">
            <FaYoutube /><span>YouTube</span>
          </a>
          <a href="mailto:theatharvavedaequity@gmail.com" className="ct-si ct-si-em">
            <FaEnvelope /><span>Email</span>
          </a>
        </div>
      </div>

      {/* COURSES STRIP */}
      <div className="ct-courses">
        <div className="ct-tag" style={{marginBottom:'6px'}}>Our Courses</div>
        <h2 className="ct-faq-title">Interested in a Course?</h2>
        <p className="ct-courses-sub">Choose from our weekend courses, NISM/NCFM certifications or Advanced Diploma</p>
        <div className="ct-courses-grid">
          {[
            { name: 'Technical Analysis',        badge: 'Weekend',      price: '₹10,999', dur: '3 Months'  },
            { name: 'Fundamental Analysis',      badge: 'Weekend',      price: '₹10,999', dur: '3 Months'  },
            { name: 'Mutual Fund Investing',     badge: 'Weekend',      price: '₹10,999', dur: '3 Months'  },
            { name: 'Crypto Trading',            badge: 'Weekend',      price: '₹10,999', dur: '3 Months'  },
            { name: 'Equity Derivatives',        badge: 'NISM VIII',    price: '₹12,999', dur: 'Lifetime'  },
            { name: 'Technical Analysis Module', badge: 'NCFM',         price: '₹10,999', dur: 'Lifetime'  },
            { name: 'Complete Bundle',           badge: 'Best Value',   price: '₹29,999', dur: '6 Months'  },
            { name: 'Advanced Diploma',          badge: 'Full Program', price: '₹99,999', dur: '1 Year'    },
          ].map((c, i) => (
            <Link
              to={`/enquiry?course=${encodeURIComponent(c.name)}&badge=${encodeURIComponent(c.badge)}&price=${encodeURIComponent(c.price)}`}
              className="ct-course-card" key={i}
            >
              <div className="ct-course-badge">{c.badge}</div>
              <div className="ct-course-name">{c.name}</div>
              <div className="ct-course-bottom">
                <span className="ct-course-price">{c.price}</span>
                <span className="ct-course-dur">{c.dur}</span>
              </div>
            </Link>
          ))}
        </div>
        <div style={{textAlign:'center', marginTop:'20px'}}>
          <Link to="/courses" className="ct-all-courses-btn">View All Courses →</Link>
        </div>
      </div>

      {/* FAQ */}
      <div className="ct-faq">
        <div className="ct-tag" style={{marginBottom:'6px'}}>Quick Answers</div>
        <h2 className="ct-faq-title">Frequently Asked Questions</h2>
        <div className="ct-faq-grid">
          <div className="ct-faq-item">
            <div className="ct-faq-q">How do I enrol in a course?</div>
            <div className="ct-faq-a">Click "Enrol Now" on any course, fill the enquiry form and our team contacts you within 24 hours with payment details.</div>
          </div>
          <div className="ct-faq-item">
            <div className="ct-faq-q">Are courses available in Hindi?</div>
            <div className="ct-faq-a">Yes! All courses are taught in Hindi and English, making them accessible to learners across India.</div>
          </div>
          <div className="ct-faq-item">
            <div className="ct-faq-q">Do I get a certificate after completion?</div>
            <div className="ct-faq-a">Yes, you receive an AVE certificate. NISM/NCFM certifications require passing the official exam separately.</div>
          </div>
          <div className="ct-faq-item">
            <div className="ct-faq-q">Is there a free demo class?</div>
            <div className="ct-faq-a">Yes! We offer a free demo for all courses. WhatsApp us or fill the form above to schedule yours.</div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="ct-footer">
        <div className="ct-footer-brand">© 2026 The Atharva Veda Equity. All rights reserved.</div>
        <div className="ct-footer-links">
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/courses">Courses</a>
          <a href="/contact">Contact</a>
        </div>
      </footer>

    </div>
  );
}

export default Contact;